export const locale = {
    lang: 'en',
    data: {
        'about': {
            'title': 'About',
            'jobTitle': 'Web and mobile application developer',
            'introductionOfMe': 'Interested in new technologies and working methods. I like to come up with ideas that to permit to improve business processes.',
            'passionateAboutDevelopment':'Passionate about development',
            'mobility': 'Mobile throughout France',
            'years': 'Years',
            'graduation': "Master's degree 2 IT",
            'myResearch': 'CDI contract search',
            'researchDescription': 'I am looking for an innovative and user-centric company to best meet the needs customer, from his idea to the final delivery of his project, or participate in the improvement of a project existing.',
            'and':'and',
            'followMeOn':'Follow me on',
        },
        'contact': {
            'contactMe': 'Contact Me',
            'notHesitateToContactMe': 'Do not hesitate to contact me',
            'identify': 'Identify',
            'enterIdentify': 'Enter your identify',
            'email': 'Email',
            'enterEmail': 'Enter your email',
            'object': 'Object',
            'enterObject': 'Enter object',
            'message': 'Message',
            'send': 'Send',
        },
        'education': {
            'title': 'Curriculum Vitae',
            'eductionTitle': 'Education',
            'experiencesTitle': 'Experiences',
            'centerOfInterest': 'Center of interest',
            'sport': 'Sport',
            'trips': 'Trips',
            'boardGames': 'Board games',
            'languages': 'Languages',
            'fluent': 'Fluent',
            'goodLevel': 'Good level',
            'french': 'French',
            'english': 'English',
            'masterDegreeTwo': "Master's degree 2 IT",
            'masterDegreeTwoDesc': "Master of degital services",
            'masterDegreeOne': "Master's degree 1 IT",
            'masterDegreeOneDesc': "General Master Computer Science",
            'bachlorDegree': "Bachelor's degree",
            'bachlorDegreeDesc': "Bachlor of Computer Science",
            'university': 'University of Lille, FR',
            'mission':'Mission',
            'technologies':'Technologies',
            'detail':'Detail',
            'tripsCountries':'Belgium, Spain, Netherlands, Swiss',
            'boardGamesPlayed':'Checkers and dominoes game, Among US, Ludo, ..etc',
            'years':'years'
        },
        'header': {
            'home': 'Home',
            'about': 'About',
            'skills': 'Skills',
            'references': 'References',
            'contactMe': 'Contact me',
        },
        'home': {
            'iAmDeveloper': 'I am developer',
        },
        'projects': {
            'title': 'Portfolio',
            'projectDetail':'Project detail',
            'sourceCode':'Source code',
        },
        'references': {
            'title': 'References',
        },
        'skills': {
            'title': 'Skills',
            'technologies': 'Technologies',
            'tools': 'Tools',
            'methodologies': 'Methodologies'
        },
    }
}